// src/actions/salaryActions.js
import api from '../api/axios';
import {
  SALARY_LIST_REQUEST,
  SALARY_LIST_SUCCESS,
  SALARY_LIST_FAIL,
} from '../constants/salaryConstants';

export const listCurrentSalaries = () => async (dispatch) => {
  try {
    dispatch({ type: SALARY_LIST_REQUEST });

    const { data } = await api.get('/salaries/current/');

    dispatch({
      type: SALARY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_LIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message,
    });
  }
};